module.exports = __webpack_public_path__ + "static/media/5-normal.7de8b8f5.png";